import { useState, useEffect, useRef } from "react";
import UserImage from "../../../src/Assets/images/avtar.svg";
import LogoutIcon from "../../../src/Assets/images/logout.svg";
import styles from "./header.module.css";
import { useGlobalContext } from "../../Context/GlobalContext";

const ProfileDropdown = ({ onOpenChange }) => {
	const {
		setCreatedBooking, 
		setNewAppointmentSlots, 
		setIsSidebarVisible, 
		loggedUser,
		loggedName,
		loggedEmail,
		setTemporaryBookingId,
		setTempBookingCreated,
		setHitTemporaryBookingApi,
		newAppointmentSlots,
		isCustomerSelected,
		selectedServices,
		setShowConflictModal,
		setSelectedBookingId,
		setSelectedServices,
	} = useGlobalContext();

	const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
	const [isClearingCache, setIsClearingCache] = useState(false);
	const dropdownRef = useRef(null);

	// Toggle dropdown
	const handleProfileToggle = () => {
		if ((newAppointmentSlots.length > 0 && isCustomerSelected) || selectedServices.length > 0) {
			setShowConflictModal(true);
			return;
		}
		setIsProfileDropdownOpen((prev) => {
			const next = !prev;
			onOpenChange?.(next);
			return next;
		});
		// resetLogoutTimer();
	};

	const handleLogout = () => {
		// Broadcast logout event to other tabs
		const channel = new BroadcastChannel('auth_channel');
		channel.postMessage('logout');
		channel.close();

		localStorage.clear();
		sessionStorage.clear();
		setCreatedBooking(null);
		setNewAppointmentSlots([]);
		setIsSidebarVisible(false);
		setTemporaryBookingId(null);
		setTempBookingCreated(false);
		setHitTemporaryBookingApi(false);
		window.location.replace("/login");
	};

	// const handleClearCache = () => {
	// 	if (isClearingCache) return;
	// 	setIsClearingCache(true);
	// 	setIsProfileDropdownOpen(false);
	// 	try {
	// 		localStorage.removeItem("tempBookingID");
	// 	} catch {}
	// 	try {
	// 		sessionStorage.removeItem("lastBookingsFetchKey");
	// 		sessionStorage.removeItem("lastTherapistListFetchKey");
	// 	} catch {}
	// 	try {
	// 		sessionStorage.removeItem("serviceList");
	// 	} catch {}
	// 	setCreatedBooking(null);
	// 	setNewAppointmentSlots([]);
	// 	setIsSidebarVisible(false);
	// 	setTemporaryBookingId(null);
	// 	setSelectedBookingId(null);
	// 	setTempBookingCreated(false);
	// 	setSelectedServices([]);
	// 	setHitTemporaryBookingApi(false);
	// 	try {
	// 		window.dispatchEvent(new CustomEvent("clearCacheRefresh"));
	// 	} catch {}
	// 	// Fallback to avoid a stuck loading state
	// 	setTimeout(() => {
	// 		setIsClearingCache(false);
	// 	}, 3000);
	// };


	const handleClearCache = () => {
		if (isClearingCache) return;
	  
		setIsClearingCache(true);
		setIsProfileDropdownOpen(false);
		onOpenChange?.(false);
	  
		try {
		  localStorage.removeItem("tempBookingID");
		  sessionStorage.removeItem("lastBookingsFetchKey");
		  sessionStorage.removeItem("lastTherapistListFetchKey");
		  sessionStorage.removeItem("serviceList");
		} catch (error) {
		  console.error("Storage clear error:", error);
		}
	  
		// Reset states
		setCreatedBooking(null);
		setNewAppointmentSlots([]);
		setIsSidebarVisible(false);
		setTemporaryBookingId(null);
		setSelectedBookingId(null);
		setTempBookingCreated(false);
		setSelectedServices([]);
		setHitTemporaryBookingApi(false);
	  
		// Dispatch refresh event
		window.dispatchEvent(new CustomEvent("clearCacheRefresh"));
	  
		// Optional: only keep fallback if absolutely necessary
		setTimeout(() => {
		  setIsClearingCache(false);
		}, 3000);
	  };
	  





	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target)
			) {
				setIsProfileDropdownOpen(false);
				onOpenChange?.(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [onOpenChange]);

	useEffect(() => {
		const handleClearCacheDone = () => {
			setIsClearingCache(false);
		};
		window.addEventListener("clearCacheRefreshDone", handleClearCacheDone);
		return () => {
			window.removeEventListener("clearCacheRefreshDone", handleClearCacheDone);
		};
	}, []);

	return (
		<div className={styles.profileDropdown} ref={dropdownRef}>
			{/* Dropdown Toggle */}
			<div
				className={styles.dropdownToggle}
				onClick={handleProfileToggle}
				role="button"
				aria-expanded={isProfileDropdownOpen}>
				<img src={UserImage} alt="user" />
			</div>

			{/* Dropdown Menu */}
			{isProfileDropdownOpen && (
				<div className={styles.dropdownMenu}>
					<ul>
						{/* <li className={styles.dropdownItem}>
							<Link to="/">
								<img src={ProfileIcon} alt="profile" />
								<span>View profile</span>
							</Link>
						</li> */}
						<li className={`${styles.dropdownItem} ${styles.loggedUserDetails}`}>
							<div className={styles.loggedUserHeader}>
								<h6>{loggedUser?.name || loggedName}</h6>
								{/* <button
									type="button"
									onClick={handleClearCache}
									className={`${styles.clearCacheButton} ${isClearingCache ? styles.clearCacheLoading : ""}`}
									disabled={isClearingCache}
								>
									<span>{isClearingCache ? "Clearing.." : "Clear cache"}</span>
								</button> */}
							</div>
							<p>{loggedUser?.email || loggedEmail}</p>
						</li>
						<li className={`${styles.dropdownItem} ${styles.logoutBtnContainer}`}>
							<button
								onClick={handleLogout}
								className={styles.logoutButton}>
								<img src={LogoutIcon} alt="logout" />
								<span>Logout</span>
							</button>
						</li>
					</ul>
				</div>
			)}
		</div>
	);
};

export default ProfileDropdown;
